import { Box, Button, Container, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useLocation } from 'react-router-dom';
import { Vocabulary } from '../../Utils/Vocabulary';

export default function Success() {
  const location = useLocation();
  const orderNumber = (location.state as any)?.orderNumber;

  return (
    <Container maxWidth="sm">
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="80vh" textAlign="center">
        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 3 }} />
        <Typography variant="h4" gutterBottom>{Vocabulary.orderSuccess}</Typography>
        {orderNumber && (
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {Vocabulary.orderNumber}: #{orderNumber}
          </Typography>
        )}
        <Typography variant="body1" color="text.secondary" mb={4}>
          {Vocabulary.orderSuccessSubtext}
        </Typography>
        <Button
          variant="contained"
          size="large"
          href="https://glassgsm.ro"
          target="_blank"
          rel="noopener noreferrer"
        >
          {Vocabulary.goToGlassGSM}
        </Button>
      </Box>
    </Container>
  );
}
